module.exports = __webpack_public_path__ + "img/SnT Global.818f8b1f.png";